import { Bell } from "@phosphor-icons/react";
import { m } from "@plannello/i18n/messages";
import { createFileRoute } from "@tanstack/react-router";
import { NotificationSettingsForm } from "@/components/notifications/SettingsForm";
import { useBreadcrumbs } from "@/components/shell/breadcrumbs";
import { Page } from "@/components/shell/Page";

/** /settings/notifications: mail links point here. */
export const Route = createFileRoute("/_app/settings/notifications")({ component: NotificationSettingsPage });

function NotificationSettingsPage() {
  useBreadcrumbs([{ label: m.nav_settings(), to: "/settings" }, { label: m.set_nav_notifications() }]);
  return (
    <Page title={m.set_nav_notifications()} icon={Bell} meta={m.ns_meta()} width="full" className="max-w-5xl">
      <NotificationSettingsForm />
    </Page>
  );
}
